import { fetchBaseQuery } from "@reduxjs/toolkit/query";

export const customBaseQuery = fetchBaseQuery({
  baseUrl: "/", // Will use your existing request function's base URL
  prepareHeaders: (headers) => {
    // Your existing request function handles auth, so we might not need this
    return headers;
  },
});
